import { FC, FormEvent, ReactNode, useEffect, useState } from "react";

interface PageSectionProps {
  title: string;
  children: ReactNode;
}

const PageSection: FC<PageSectionProps> = ({ title, children }) => {
  return (
    <div className="max-w-[90%] sm:max-w-[900px] mx-auto mb-20 min-h-[calc(100vh-400px)]">
      <h1 className="gradation-text-short text-2xl mt-6 text-[26px] font-bold">{title}</h1>
      <div className="mt-10">
        {children}
      </div>
    </div>
  );
};

export default PageSection;